import { render, staticRenderFns } from "./GamesShowRoute.vue?vue&type=template&id=7a8f1e47&scoped=true&lang=pug&"
import script from "./GamesShowRoute.vue?vue&type=script&lang=js&"
export * from "./GamesShowRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f1e47",
  null
  
)

export default component.exports